
<template>

<div>  
  <div v-if="!loading">  


        <h4 class="dashboard-heading">Contact permission</h4>
        <p class="smaller">ClassForKids would love to send you  offers for Classes, products and services from selected clubs and third parties via email, text, and through the Platform. Please let us know if you would like us to contact you or not by selecting one of the options below.
        </p>


        <!-- <label for="permissions" class="strong">I agree to opt in to receive ClassForKids Marketing Messages  as described in clause 7 of these Terms of Use. I understand that this means ClassForKids will send me offers for Classes, products and services from selected Organisers and third parties via email, text, and through the Platform. I have read and understand the privacy statement on the Platform. </label> -->


        



          <div class="row">
            <div class="columns small-12">    
              <label class=""  for="yes">
                <input type="radio" id="yes" name="permissions" value="1" v-model="status">
                Yes please
              </label>
            </div>

            <div class="columns small-12">
              <label class="" for="no">
                <input type="radio" id="no" name="permissions" value="0" v-model="status">
                No thanks
              </label>
            </div>
          </div>
      </div>
      <div v-else>
        <LoadingSpinner :loading="loading" />"
      </div>

</div>



</template>






<script>
import LoadingSpinner from '../../app/bookingservice/v4/components/Global/LoadingSpinner';
export default {
  name: 'MarketingPermissions',
  data() {
    return {
      loading: true
    };
  },
  computed: {
    status: {
      get() {
        return this.$store.getters.marketingPreferencesStatus;
      },
      set(value) {
        this.$store.dispatch('SET_PREFERENCES', { status: value });
      }
    }
  },
  methods: {},

  components: {LoadingSpinner},
  async created() {
    await this.$store.dispatch('GET_PREFERENCES');
    this.loading = false;
  }
};
</script>

<style>
</style>
